import { render } from "./SpacesManagePopUp.vue?vue&type=template&id=994fdb90&scoped=true&ts=true"
import script from "./SpacesManagePopUp.vue?vue&type=script&lang=ts"
export * from "./SpacesManagePopUp.vue?vue&type=script&lang=ts"

import "./SpacesManagePopUp.vue?vue&type=style&index=0&id=994fdb90&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-994fdb90"]])

export default __exports__